import React from 'react';
import { getWorkTypeName } from './utils';
import TaskTitleLink from './TaskTitleLink';
import { ContentProps } from 'src/types/activityUpdate';

const TaskSolvedContent: React.FC<ContentProps> = ({
    user,
    workType,
    taskTitle,
    taskId,
    grossWorkTime
}) => {
    const workTypeText = workType ? getWorkTypeName(workType) : '';
    return (
        <span>
            <strong>{workTypeText}</strong> work{' '}
            <TaskTitleLink taskId={taskId} title={taskTitle} /> was solved by{' '}
            <strong>{user}</strong> added a proof of work
            {grossWorkTime ? ` after ${grossWorkTime}` : ''}
        </span>
    );
};

export default TaskSolvedContent;
